module.exports = __webpack_public_path__ + "static/media/mnist.e2ae4adc.png";